var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "154", height: "161", viewBox: "0 0 154 161", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "exported"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "g",
        { opacity: ".2", stroke: "#111", strokeLinecap: "square", strokeWidth: "3.24" },
        React.createElement("path", { d: "M24 2h128v157H24zM52.444 44.818h71.112M52.444 80.5h71.112M52.444 116.182H80.89" })
      ),
      React.createElement(
        "g",
        { transform: "translate(0 9)" },
        React.createElement("circle", { fill: "#4BB543", cx: "35.5", cy: "35.5", r: "35.5" }),
        React.createElement("path", { stroke: "#FFF", strokeWidth: "5", strokeLinecap: "square", d: "M18.933 37.867l9.467 9.466 23.667-23.666" })
      )
    )
  );
});


// WEBPACK FOOTER //
// ./src/static/images/exported.svg